




















































import Vue from "vue"
import axios from "axios"
import { Component } from "vue-property-decorator"
import { GenericResponse } from "@/data/models/response"
import router from "@/router"

@Component({
    components: {},
})
export default class About extends Vue {
    form: {
        username: string,
        password: string,
        dirty: boolean,
    } = {username: "", password: "", dirty: false}
    loginFailed: boolean = false
    loading: boolean = false

    onSubmit(e: Event) {
        e.preventDefault()
        this.form.dirty = true

        if (this.validateUsername && this.validatePassword) {
            this.loading = true
            axios.post(`${process.env.VUE_APP_BASE_URL}/auth/login`, this.form).then(
                response => {
                    this.loading = false
                    if (response.status != 200) {
                        this.loginFailed = true
                        return
                    }

                    let data = response.data as GenericResponse<{ token: string }>

                    if (!data.success) {
                        this.loginFailed = true
                        return
                    }

                    this.loginFailed = false
                    localStorage.setItem("jwt", data.data!.token)

                    router.push({name: "upload"})
                },
                reason => {
                    this.loginFailed = true
                    this.loading = false
                }
            )
        }
    }

    get validateUsername(): boolean {
        return !this.form.dirty || this.form.username.length >= 4
    }

    get validatePassword(): boolean {
        return !this.form.dirty || this.form.password.length >= 8
    }
}
